import { EventData, EventFunction, events } from "./types";

export class Event {
  static observers: Map<string, { func: EventFunction; filters: Set<events> }> =
    new Map();

  static subscribe({
    func,
    filters = [],
    key = "",
  }: {
    func: EventFunction;
    filters: Array<events>;
    key: string;
  }) {
    console.log("SUBSCRIBE: ", filters, key, {
      func,
      filters: new Set(filters),
    });
    this.observers.set(key, { func, filters: new Set(filters) });
  }

  static unsubscribe({ key }: { key: string }) {
    this.observers.delete(key);
  }

  static notify({ data }: { data: EventData }) {
    console.log("SOME EVENT TR: ", data);
    this.observers.forEach(
      ({ filters, func }) => filters.has(data.type) && func(data),
    );
  }
}
